import React from 'react';
import { Box, Typography, Button } from '@mui/material';

export default class GameErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[GameErrorBoundary]', error, info?.componentStack);
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: 320, gap: 2, p: 4,
          textAlign: 'center',
        }}>
          <Typography variant="h6" sx={{ color: 'var(--color-text, #fff)' }}>
            Something went wrong
          </Typography>
          <Typography variant="body2" sx={{ color: 'var(--color-subText, #aaa)', maxWidth: 360 }}>
            This game encountered an error. Try again or refresh the page.
          </Typography>
          <Button
            variant="contained"
            onClick={this.handleRetry}
            sx={{
              mt: 1,
              bgcolor: 'var(--color-primary, #00F5FF)',
              color: '#000',
              fontWeight: 700,
              borderRadius: 'var(--radius-button, 6px)',
              '&:hover': { bgcolor: 'var(--color-primaryHover, #3DF8FF)' },
            }}
          >
            Try Again
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}
